<template>
  <div>
    <AppButtonLink
      :to="toLogin"
      class="text-14-400"
      icon-left="fl:arrow_left"
      icon-left-size="11px"
      :label="$t('label.backToLogin')"
    />
    <q-separator
      class="q-mt-lg"
      color="grey-2"
    />
  </div>
</template>

<script>
import AppButtonLink from 'common/components/buttons/AppButtonLink';

export default {
  name: 'AuthBackToLogin',
  components: { AppButtonLink },
  computed: {
    toLogin() {
      return { name: ENUMS.ROUTES.AUTH.SIGNIN };
    },
  },
};
</script>
